<template>
  <Dialog
    v-model:visible="localVisible"
    modal
    :header="headerMsg || `Oops Error Occured !!`"
    :style="{ width: '25rem' }"
    :closable="false"
  >
    <div class="flex items-center gap-4">
      <i class="pi pi-exclamation-triangle !text-3xl" />
      <!-- Use v-html to render HTML content in the message -->
      <span
        v-if="message"
        v-html="message"
      />
    </div>
    <template #footer>
      <template v-if="!hideCloseButton">
        <Button
          label="Ok"
          icon="pi pi-check"
          @click="confirmAction"
        />
      </template>
    </template>
  </Dialog>
</template>

<script>
  import { defineComponent, ref, watch } from "vue";

  export default defineComponent({
    name: "ErrorDialog",
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      hideCloseButton: {
        type: Boolean,
        default: false
      },
      headerMsg: {
        type: String
      },
      message: {
        type: String,
        required: true
      },
      onConfirm: {
        type: Function,
        required: true
      }
    },
    emits: ["update:visible", "confirm"],
    setup(props, { emit }) {
      const localVisible = ref(props.visible);

      // Watch the visible prop and update localVisible accordingly
      watch(
        () => props.visible,
        (newVal) => {
          localVisible.value = newVal;
        }
      );

      // Watch localVisible and emit changes to the parent
      watch(
        () => localVisible.value,
        (newVal) => {
          emit("update:visible", newVal);
        }
      );

      const closeDialog = () => {
        localVisible.value = false;
      };

      const confirmAction = () => {
        if (props.onConfirm) props.onConfirm();
        closeDialog();
      };

      return {
        localVisible,
        closeDialog,
        confirmAction
      };
    }
  });
</script>
